module.exports = __webpack_public_path__ + "media/svg/gb-sct-c952b07d.svg";